<!--
 * @Author: 汪俊洪
 * @Date: 2025-05-06 10:34:48
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2025-05-28 09:00:50
 * @Description:
-->
<template>
  <div style="background: #f5f5f5; padding: 12px; margin: -12px 0 12px">
    <div style="padding-bottom: 12px">
      <span style="font-weight: 700; margin-right: 8px">AI提取地址</span>
      <span>支持从文本、jpg\png\jpeg图片、pdf文件中提取地址</span>
    </div>
    <div>
      <el-input
        type="textarea"
        :rows="3"
        placeholder="请输入地址"
        v-model="content"
        resize="none"
        maxlength="500"
      >
      </el-input>
    </div>
    <div style="display: flex; align-items: center; padding: 12px 0 0">
      <div style="flex: 1">
        <el-button
          size="small"
          :loading="loading"
          @click="textExtraction"
          type="primary"
          class="plc-btn"
          >文本提取</el-button
        >
      </div>
      <el-button size="small" :loading="loading" @click="pasteInfo"
        >粘贴并提取</el-button
      >
      <el-button size="small" :loading="loading" @click="importInfo"
        >上传文件提取</el-button
      >
    </div>
    <el-upload
      v-show="false"
      ref="fielUplod"
      :on-success="fileSuccess"
      :before-upload="beforeUploadFile"
      :with-credentials="true"
      accept=".pdf, .png, .jpg, .jpeg"
      :headers="headerMsg"
      :action="actionUrl1"
    >
      <el-button type="primary">上传文件</el-button>
    </el-upload>
  </div>
</template>

<script>
import { getAccessToken } from '@/utils/userInfo'

export default {
  data () {
    return {
      content: '',
      loading: false,
      headerMsg: {
        Authorization: 'Bearer ' + getAccessToken()
      },
      subLoading: false,
      actionUrl1: window.SITE_CONFIG.apiURL + '/front/fileupload/alioss/upload'
    }
  },
  methods: {
    // 商品信息上传
    importInfo () {
      if (this.subLoading) {
        return false
      }
      this.$refs.fielUplod.$el.childNodes[0].childNodes[1].click()
    },
    // 导入成功
    fileSuccess (response) {
      this.subLoading = false
      const url = response.data.url
      this.getResult({ fileUrl: url })
    },
    textExtraction () {
      if (!this.content) {
        return this.$message.warning('请输入地址内容')
      }
      this.getResult({ content: this.content })
    },
    async pasteInfo () {
      try {
        const content = await navigator.clipboard.read()
        if (!content) {
          return this.$message.warning('剪切板内容为空')
        }
        // 如果是单张图片
        if (
          content.length === 1 &&
          content[0].types &&
          content[0].types.length &&
          content[0].types[0].startsWith('image/')
        ) {
          const type = content[0].types[0]
          const imageBlob = await content[0].getType(type)
          const file = new File([imageBlob], `paste.${type.split('/')[1]}`, {
            type
          })
          this.uploadImg(file)
          return
        }
        const str = await navigator.clipboard.readText()
        if (!str) {
          return this.$message.warning('剪切板内容未识别，请重新复制内容！')
        }
        this.content = await navigator.clipboard.readText()
        this.getResult({ content: this.content })
      } catch (err) {
        console.error('无法访问剪切板: ', err)
      }
    },
    uploadImg (file) {
      const formData = new FormData()
      formData.append('file', file) // 'file'是后端接收的字段名
      this.$http
        .post('/front/fileupload/alioss/upload', formData)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.getResult({ fileUrl: res.data.url })
          }
        })
    },
    getResult (obj) {
      if (this.loading) {
        return
      }
      this.loading = true
      this.$http
        .post('/help/ai/user/addrIdentify', obj)
        .then(({ data: res }) => {
          this.loading = false
          if (res.code === 0 && res.data.parsedAddress) {
            const { province, city, district, detail, name, phone } =
              res.data.parsedAddress
            this.$emit('update', {
              province,
              city,
              area: district,
              address: detail,
              receiveGoodsPerson: name,
              receiveGoodsPhone: phone
            })
          }

          console.log(res)
        })
    },
    beforeUploadFile () {
      if (this.subLoading) {
        return false
      }
      this.subLoading = true
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
